import { ReactNode } from 'react'

type AlertVariant = 'default' | 'success' | 'warning' | 'danger'

interface AlertProps {
    variant?: AlertVariant
    icon?: ReactNode
    title?: string
    children: ReactNode
    className?: string
}

const variantClasses: Record<AlertVariant, string> = {
    default: 'border-slate-200 bg-slate-50 text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100',
    success: 'border-green-200 bg-green-50 text-green-900 dark:border-green-700 dark:bg-green-900/30 dark:text-green-300',
    warning: 'border-yellow-200 bg-yellow-50 text-yellow-900 dark:border-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300',
    danger: 'border-red-200 bg-red-50 text-red-900 dark:border-red-700 dark:bg-red-900/30 dark:text-red-300',
}

export const Alert = ({ variant = 'default', icon, title, children, className = '' }: AlertProps) => (
    <div className={`flex items-start gap-2 rounded-lg border p-3 ${variantClasses[variant]} ${className}`}>
        {icon && <div className="mt-0.5 shrink-0">{icon}</div>}
        <div className="min-w-0">
            {title && <p className="text-sm font-semibold">{title}</p>}
            <div className="text-sm">{children}</div>
        </div>
    </div>
)
